import React from 'react'
import './coversation.css';
import PropTypes from 'prop-types';
import {useNavigate} from 'react-router-dom';
import { GoDotFill } from "react-icons/go";
function Conversation({conversation,
    setUnreadMessageConversationIcon,
    unreadMessageConversationIcon, 
    lastMessage
    }) {

    const navigate = useNavigate();
    const cloudfrontUrl = process.env.REACT_APP_CLOUDFRONT_URL;


    function truncateAtWord(str, maxLength) {
    if (str.length <= maxLength) {
        return str;
    }

    const truncated = str.slice(0, maxLength + 1);
    const lastSpaceIndex = truncated.lastIndexOf(' ');

    if (lastSpaceIndex > 0) {
        return truncated.slice(0, lastSpaceIndex) + '...';
    }

    return truncated.slice(0, maxLength) + '...';
    }

    const goToConversationPage = () => {
        // remove conversation ID from state after reading messages
        setUnreadMessageConversationIcon(prev=>
            prev.filter(id => id !== conversation._id)
        );
        navigate(`/messages/${conversation._id}`);
    }
        

  return (
    <div className='single-conversation-container' onClick={goToConversationPage}>

        <div className="left-side-container">
            <div className="unreadMessages-dot-container">
                {unreadMessageConversationIcon && unreadMessageConversationIcon.includes(conversation._id) &&
                    <GoDotFill className='unreadMessages-dot'/>
                }
            </div>
            <img className='profile-picture' src={`${cloudfrontUrl}/static/no-profile-pic.webp`} alt="" />
        </div>
        <div className="right-side-container">
            <h3 className='username-title'>Anonymous User</h3>      
            <p className='message-preview'>
            {
                unreadMessageConversationIcon && unreadMessageConversationIcon.includes(conversation._id) && lastMessage
                ? truncateAtWord(lastMessage, 69) // If there's an unread message icon and a lastMessage, truncate lastMessage
                : truncateAtWord(conversation.lastMessage, 69) // Otherwise, truncate conversation's last message
            }
            </p>  
        </div>
    </div>
  )
}

Conversation.propTypes = {
    conversation: PropTypes.shape({
        lastMessage: PropTypes.string,
        _id: PropTypes.string,
    }),
    setUnreadMessageConversationIcon: PropTypes.func,
    unreadMessageConversationIcon: PropTypes.array,
    lastMessage: PropTypes.string,
};

export default Conversation